<template>
  <div class="mod-choose">
    <div
      v-for="(service, index) in product?.detail?.services"
      :key="service.serviceId || index"
    >
      <div class="cell-header clearfix flex-hl-vl">
        <div
          class="flight"
        >
          <div class="orgdst departure">
            <div class="flight-no">{{ itinerary.orgDsts[index].flightNo }}</div>
            <div class="time">
              <a-popover placement="bottom" overlayClassName="flight-time-popover">
                <template slot="content">
                  <l8-icon type="icon-shijianlishijilujishizhongbiaoxianxing"></l8-icon>
                  此为当地时间
                </template>
                <span>{{ itinerary.orgDsts[index].departureTime | getTime }}</span>
              </a-popover>
            </div>
            <div class="airport">{{ itinerary.orgDsts[index].departureAirPortName }}{{ itinerary.orgDsts[index].departureTerminal }}</div>
            <div class="cutOffTime" v-if="itinerary.orgDsts[index].cutOffTime">航班起飞前{{ itinerary.orgDsts[index].cutOffTime }}分钟停止办理乘机手续</div>
          </div>
          <div class="more-info">
            <div class="wrapper">
              <div class="type" v-if="itinerary.orgDsts[index].stopQuantity">经停: {{ itinerary.orgDsts[index].stopCitys | stopCity }}</div>
              <div class="type" v-else>直飞</div>
              <div class="duration" v-if="!ifInternational?.()">{{ itinerary.orgDsts[index] | duration }}</div>
              <div class="duration" v-else>{{ itinerary.orgDsts[index].duration | transferDurationSimple }}</div>
              <div class="aircraft" v-if="itinerary.orgDsts[index].aircraftCode">机型: {{ itinerary.orgDsts[index].aircraftCode }}</div>
            </div>
          </div>
          <div class="orgdst arrival">
            <div class="flight-no"></div>
            <div class="time">
              <a-popover placement="bottom" overlayClassName="flight-time-popover">
                <template slot="content">
                  <l8-icon type="icon-shijianlishijilujishizhongbiaoxianxing"></l8-icon>
                  此为当地时间
                </template>
                <span>{{ itinerary.orgDsts[index].arrivalTime | getTime }}</span>
                <span class="gt-day">{{ itinerary.orgDsts[index] | gtDay }}</span>
              </a-popover>
            </div>
            <div class="airport">{{ itinerary.orgDsts[index].arrivalAirPortName }}{{ itinerary.orgDsts[index].arrivalTerminal }}</div>
          </div>

        </div>
        <div class="date">
          <div>
            <span class="label">选定日期: </span>
            {{ itinerary.orgDsts[index].departureDate }}
          </div>
          <div>
            <span class="label">舱位: </span>
            {{ service.cabinCode }}舱
          </div>
        </div>
        <div class="product">
          <div :class="['productName', 'singe-line', product.className]">
            <span class="label">产品名称: </span>
            <strong :title="service.productName">{{ service.productName }}</strong>
            <template v-for="benefit in service.benefits">
              <l8-icon
                v-if="!benefit.disabled"
                :key="benefit.code"
                :type="benefit.icon"
              >
              </l8-icon>
            </template>
          </div>
          <div v-if="service.fareDetails[0].fares[0].discount">
            <span class="label">折扣: </span>
            {{ service.fareDetails[0].fares[0].discount | discount }}
          </div>
        </div>
        <div class="benefitInfo" v-if="isTransfer">
          <span class="label">权益信息 </span>
          <div v-if="service?.benefit">
            <rule-list :service="service" :isJJC="isJJC"></rule-list>
          </div>
          <div v-else>--</div>
        </div>
        <div class="total">
          <template v-if="!ifInternational">合计: {{ service.fareDetails[0].fares[0].amount }}元</template>
          <a class="rechoose" @click="onCancel" v-if="!index">
            <l8-icon type="icon-edit"></l8-icon>
            <span class="rechoose-text">重新选择</span>
          </a>
          <span class="rechoose" v-else></span>
        </div>
      </div>
      <div class="cell-body clearfix" v-if="!isTransfer">
        <div class="benefits" v-if="service.benefit">
          <h4>行李额说明</h4>
          <benefit-luggage :list="service.benefit?.benefits?.[0]?.luggageBenefitDetails"></benefit-luggage>
          <h4>其他权益</h4>
          <div v-for="benefit in service.benefit.benefits[0].benefitDetailsWithoutLuggage" :key="benefit.code" class="flex-ht-vc">
            <template v-if="!benefit.disabled">
              <l8-icon :type="benefit.icon"></l8-icon>
              <span v-html="benefit.text" style="margin-left: 5px"></span>
            </template>
          </div>
          <div style="margin-top: 10px">
            <l8-icon type="icon-jinggaoicon"></l8-icon>
            <span> 部分权益按各机场<strong> 实际保障 </strong>为准 </span>
          </div>
          <div v-if="showMealBenefitByCode(service)">
            <l8-icon type="icon-jinggaoicon"></l8-icon>
            <span> 餐食提供以机上<strong> 实际保障 </strong>为准 </span>
          </div>
          <div class="quantity" v-if="service.inventory">
            <l8-icon type="icon-piao"></l8-icon>
            剩余票量: {{ service.inventory | getInventory }}
          </div>
        </div>
        <div class="rules">
          <h4>退改签规则</h4>
          <div class="detail">
            <!-- <a-spin v-if="!isReady"></a-spin> -->
            <template v-if="!ifInternational?.()">
              <table v-if="service.refundChangeFees">
                <colgroup>
                  <col style="width: 72px;">
                </colgroup>
                <thead>
                  <tr>
                    <th>时限</th>
                    <th v-for="(change, changeIndex) in service.refundChangeFees[0].change" :key="'th' + change.takeoffFrom">
                      <template v-if="changeIndex === 0">离站时间前{{ -change.takeoffFrom }}小时( 不含 )以内至航班起飞后</template>
                      <template v-else-if="changeIndex === (service.refundChangeFees[0].change.length - 1)">离站时间前{{ -change.takeoffTo }}小时( 含 )以外</template>
                      <template v-else>离站时间前{{ -change.takeoffTo }}小时( 含 )至{{ -change.takeoffFrom }}小时( 不含 )</template>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>变更费（每次）</td>
                    <td v-for="change in service.refundChangeFees[0].change" :key="change.takeoffFrom">
                      {{ isJJC ? '' : (change.changeRefundDesc || change.amount) | ruleFee('免收变更费（每次）') }}
                    </td>
                  </tr>
                  <tr>
                    <td>退票费</td>
                    <td v-for="refund in service.refundChangeFees[0].refund" :key="refund.takeoffFrom">
                      {{ isJJC ? '' : (refund.changeRefundDesc || refund.amount) | ruleFee('免收退票费') }}
                    </td>
                  </tr>
                  <tr>
                    <td>签转</td>
                    <td v-for="signed in service.refundChangeFees[0].signed" :key="signed.takeoffFrom">
                      {{ (!isJJC && signed.canTran) ? '允许' : '不允许' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
            <template v-else>
              <div class="refund-changes-detail-int" v-html="getRefundChangeFeesInt(service)"></div>
            </template>
          </div>
          <!-- <div v-if="!ifInternational?.()">
            <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 以上退改签费用标准仅供参考，请以实际情况为准。<br/>
            <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 客票变更时，需同时收取票价价差和变更手续费。
            <div v-if="product.className === 'business'" class="bussiness-tip">
              <h6>关于公务舱产品退改签的补充说明</h6>
              <p>1、任何情况均不得签转至外航的头等舱、公务舱；</p>
              <p>2、如无法提供公务舱座位时，提供以下四种处理办法：</p>
              <p>（1）更改为后续航班公务舱座位，票款不退；</p>
              <p>（2）乘坐本航班或后续航班经济舱座位，旧票全退、重出新票；</p>
              <p>（3）签转至与我司有合作协议的外航的经济舱，票款不退；</p>
              <p>（4）放弃行程，票款非自愿全退。</p>
            </div>
          </div>
          <div v-else>
            <span class="primary-color">1.如您购买往返客票，退改费将按照去回程中更严格一方的标准收取，具体请以实际审核退改金额为准。</span><br/>
            2.因汇率等时有变动，以上手续费仅供参考，具体可退税费需人工核实，以实际审核退改金额为准。<br>
            <span class="primary-color">另: 儿童变更/退票手续费按照成人相应规定执行。 不占座婴儿变更/退票免收手续费。</span><br/>
          </div> -->
          <refund-rules-detail :ifInternational="ifInternational?.()"></refund-rules-detail>
        </div>
      </div>
      <div class="transfer" v-if="itinerary.itineraryType === 'LC' && index === 0">
        中转{{ itinerary.orgDsts[index].arrivalName }}时长：{{ itinerary.orgDsts | transferDuration }}
      </div>
    </div>
  </div>
</template>

<script>
import '../css/choose.less'
import ruleList from './Rule'
import benefitLuggage from '@/components/benefits/luggage'
import refundRulesDetail from '@/components/benefits/refund-rules-detail'
import getAppInfo from '@/utils/from'

const airline = window.__MICRO_ROOT__?.airline

export default {
  components: {
    ruleList,
    benefitLuggage,
    refundRulesDetail
  },
  props: {
    itinerary: Object,
    product: Object,
    segment: Object,
    isJJC: Boolean,
    isTransfer: Boolean,
    ifInternational: Boolean
  },
  data () {
    return {
      readys: [],
      appInfo: getAppInfo()
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  computed: {
    isReady () {
      const { readys } = this
      let flag = true

      if (!readys.length) {
        return false
      }

      readys.forEach(ready => {
        if (!ready) {
          flag = false
        }
      })

      return flag
    }
  },
  methods: {
    onCancel () {
      this.$emit('cancel')
    },
    getRefundChangeFeesInt (service) {
      return service.refundChangeFeesInt?.cnRule?.replaceAll('\n', '<br>')
    },
    // TODO: CMS 配置
    showMealBenefitByCode (service) {
      const { ifInternational } = this
      const prodCabinCode = service.prodCabinCode?.toLocaleLowerCase()
      let flag = false
      if (airline !== '8L') {
        return flag
      }
      if (ifInternational?.()) {
        return flag
      }
      if (!['czjjc', 'zkjjc'].includes(prodCabinCode)) {
        flag = true
      }
      return flag
    }
  }
}
</script>
